module.exports = __webpack_public_path__ + "static/media/social-twitter-32px.3e428cdf.svg";